// This is our custom Bugsnag config file, it is NOT supported by @bugsnag/js library
export const config = {
  /*
  - the stages we want to send events to Bugsnag for
  - add 'development' to this array to turn on sending events on localhost
   */
  stages: ['production', 'staging'],
};
